import { MediaType } from "constants/enums";
import { DirectUploadMedia } from "libs/directUpload";

// The API hands back a playable `videoUrl`, never the media record, so there is
// nothing to show a media picker until we wrap the url. Only `url`,
// `mediaType` and `fileName` are ever read for a preview — the rest is filler
// and must not be sent anywhere.
export const toVideoPreviewMedia = (
  videoUrl: string | null
): DirectUploadMedia | null => {
  if (!videoUrl) {
    return null;
  }

  return {
    id: videoUrl,
    url: videoUrl,
    key: "",
    fileName: "",
    mediaType: MediaType.VIDEO,
    contentType: "video/mp4",
    size: 0
  };
};
